// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';
import envConfig from './envConfig';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: envConfig('firebaseApiKey'),
  authDomain: envConfig('firebaseAuthDomain'),
  projectId: envConfig('firebaseProjectId'),
  storageBucket: envConfig('firebaseStorageBucket'),
  messagingSenderId: envConfig('firebaseSenderId'),
  appId: envConfig('firebaseAppId'),
  measurementId: envConfig('firebaseMeasureId')
};

export const EnableCouponRemoteConfig = 'EnableCoupon';

// Initialize Firebase
const app = initializeApp(firebaseConfig, 'firebaseApp');
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

const remoteConfig = getRemoteConfig(app);
remoteConfig.settings = {
  minimumFetchIntervalMillis: 3600000, // How often to allow fetches from firebase (1 hour)
  fetchTimeoutMillis: 10000 // 10 seconds timeout (adjust as needed)
};

remoteConfig.defaultConfig = {
  EnableCoupon: JSON.stringify({
    enable: false,
    coupon_code: '',
    discount_percentage: 0
  })
};

export { remoteConfig };
